<template>
    <div class="field-wrap reference">
        <!-- <label v-if="label" style="display: block;">{{ label }}</label> -->
        <a v-on:click.prevent="$emit('click')" href="#" class="button button--icon-gear">{{
            description
        }}</a>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {},
    created() {},
    mounted() {},
    props: {
        label: null,
        description: null
    }
};
</script>
